import { Modal, Row, Col } from 'react-bootstrap';
import Rating from './Rating';

const ReviewDetailModal = ({ show, review, onHide, onPhotoClick }) => {
  if (!review) return null;

  const handleImageClick = (imageIndex) => {
    // Open photo viewer with only this review's images
    onPhotoClick(review.images, imageIndex);
    onHide(); // Close modal when opening photo viewer
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Review Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <Rating value={review.rating} />
            <p className="mb-1">
              <strong>{review.name}</strong>
            </p>
            {review.createdAt && (
              <p className="text-muted small">
                {new Date(review.createdAt).toLocaleDateString()}
              </p>
            )}
          </Col>
        </Row>

        {review.variant && (
          <Row className="mb-2">
            <Col>
              <p className="text-muted small mb-0">
                <strong>Variant:</strong> {review.variant}
              </p>
            </Col>
          </Row>
        )}

        {review.comment && (
          <Row className="mb-3">
            <Col>
              <p>{review.comment}</p>
            </Col>
          </Row>
        )}

        {review.images && review.images.length > 0 && (
          <Row>
            <Col>
              <h6>Photos ({review.images.length})</h6>
              <div className="d-flex flex-wrap gap-2">
                {review.images.map((image, idx) => (
                  <img
                    key={idx}
                    src={image}
                    alt={`Review ${idx + 1}`}
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      cursor: 'pointer',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                    onClick={() => handleImageClick(idx)}
                  />
                ))}
              </div>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ReviewDetailModal;
